import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import Styles from "./macherbusRankedProject.lit.scss";
import type {DirectiveResult} from "lit/directive.js";
import {templateContent} from "lit/directives/template-content.js";
import type {Nullable} from "../../bootstrap/common/types";

@customElement("eop-macherbus-ranked-project")
export class EopMacherbusRankedProject extends LitElement {

    public static readonly styles = Styles;

    @property({attribute: "content"})
    public contentId: string;
    @property({attribute: "project-id"})
    public projectId: string;
    @property({attribute: "image-src"})
    public imageSrc: string;
    @property({attribute: "image-alt"})
    public imageAlt: string;
    @property({state: true})
    public rank: number;
    @state()
    private votesCast: Nullable<number> = null;

    private textualContent: DirectiveResult;

    public connectedCallback(): void {
        super.connectedCallback();

        const textualContentTemplate = this.resolveTemplateElement(this.contentId);
        if (textualContentTemplate !== null) {
            this.textualContent = templateContent(textualContentTemplate);
        }
    }

    //@formatter:off
    public render(): TemplateResult {
        return html`
            <div class="project-tile">
                <div class="tile-image">
                    <eop-responsive-image 
                            image-src=${this.imageSrc}
                            image-alt=${this.imageAlt}
                            fixed-aspect-ratio="true"
                            max-crop-threshold="0.25"
                    ></eop-responsive-image>
                    <div class="project-ranking">
                        <div class="rank">${this.rank}</div>
                        ${this.renderVotesCast()}
                    </div>
                </div>
                <div class="tile-non-image">
                    <div class="tile-text reverse-background">
                        ${this.textualContent}
                    </div>
                </div>
            </div>
        `;
    }
    //@formatter:on

    private renderVotesCast(): Nullable<TemplateResult> {
        if (this.votesCast === null) {
            return null;
        }

        return html`
            <div class="votes">${this.votesCast} <eop-msg key="VOTES_CAST_LABEL"></eop-msg></div>
        `;
    }

    public setRanking(rank: number, votesCast: Nullable<number>): void {
        this.rank = rank;
        this.votesCast = votesCast;
    }

    public compareTo(other: EopMacherbusRankedProject): number {
        return this.rank - other.rank;
    }
}